export function ContactsSection() {
  return (
    <section id="contact" className="contacts-section">
      <div className="contacts-band">
        <div className="contacts-title">
          <span className="eyebrow">05 — CONTACT</span>
          <h2>
            Got an idea?
            <br />
            Let's make it real.
          </h2>
        </div>
        <div className="contacts-actions">
          <a className="btn" href="mailto:company@trickyleaf.com">
            company@trickyleaf.com
          </a>
          <span>Viale delle Legioni Romane 43 · Milan</span>
        </div>
      </div>
    </section>
  );
}
